import React from 'react';

import { showModal } from 'modal.react.js';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';

import area from 'components/shared/GlobalModalArea/area';
import Modal from 'components/shared/GlobalModalArea/Modal';
import ProposalSettings from 'components/shared/ProposalSettings';
import { ITINERARIES_ITEM_TYPES } from 'constants/index';
import { setActionButtonDataAction } from 'store/itinerariesItem';
import { itinerariesItemDataSelector } from 'store/itinerariesItem/selectors';
import { buildItinerariesItemRoute } from 'store/itinerariesItem/thunks';
import { accountIdSelector } from 'store/user/selectors';
import axios from 'utils/axios';
import { useItinerariesItemContext } from 'utils/itineraries/context';

import s from './index.module.css';

const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : window.location.origin;

function useProposalSettings() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { itemType, withMultipleUsersWarning } = useItinerariesItemContext();
  const accountId = useSelector(accountIdSelector);
  const itinerariesItem = useSelector(itinerariesItemDataSelector);
  const params = useParams<{ itemId?: string }>();

  const openActionButtonModal = () => {
    const proposalType = (() => {
      if (itemType === ITINERARIES_ITEM_TYPES.LOOKBOOK) return 'lookbooks';
      if (itemType === ITINERARIES_ITEM_TYPES.ITINERARY) return 'itineraries';
      return null;
    })();

    if (!proposalType) return;

    const actionButtonUrl = `${baseUrl}/acc/${accountId}/${proposalType}/${itinerariesItem.id}/action_buttons/button_settings/edit?iframe=true`;

    showModal(area, (res) => {
      const handleMessage = (event: MessageEvent<any>) => {
        if (event.data === 'closeModal') {
          if (params?.itemId) {
            axios.get(buildItinerariesItemRoute(accountId, params.itemId)).then(({ data }) => {
              if (!data?.actionButton) return;
              dispatch(setActionButtonDataAction(data.actionButton));
            });
          }

          res();
        }
      };
      window.addEventListener('message', handleMessage);

      const unregister = history.listen(() => {
        res();
        window.removeEventListener('message', handleMessage);
      });

      const handleClose = () => {
        res();
        unregister();
      };

      return (
        <Modal contentClassName={s.shareModal} isOpen toClose={handleClose} withoutCloseBtn>
          <iframe allow="same-origin" src={actionButtonUrl} className={s.shareModalIframe}></iframe>
        </Modal>
      );
    });
  };

  const openSettingsModal = async () => {
    const { settings, id } = itinerariesItem;

    await showModal(area, (res) => (
      <ProposalSettings
        id={id}
        settings={settings}
        onClose={res}
        withMultipleUsersWarning={withMultipleUsersWarning as any}
      />
    ));
  };

  return { openSettingsModal, openActionButtonModal };
}

export { useProposalSettings };
